import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import CountryForm from "../form";

const UpdateCountry = () => {
  const { countryId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Country" />
      <div className="p-6 max-w-2xl">
        <CountryForm countryId={countryId} />
      </div>
    </div>
  );
};

export default UpdateCountry;
